export default __webpack_public_path__ + "static/media/twitter.31504579.jpg";